<template>
  <svg>
    <path :d="path" :fill="fill" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    path: {
      type: String,
      required: true
    },
    fill: {
      type: String,
      default: "#CDCDCD"
    }
  }
}
</script>

<style scoped>
  svg {
    filter: scale(1.5);
  }
</style>